import { useCallback, useSyncExternalStore } from 'react';

export const wideLayout = window.matchMedia('(width >= 48rem) and (orientation: landscape)');

export function useMediaQuery(list: MediaQueryList): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    [list],
  );
  return useSyncExternalStore(subscribe, () => list.matches);
}
